import find from 'lodash/find';
import get from 'lodash/get';

const selectGamePath = (challenges, gameKey) => get(find(challenges, { application: gameKey }), 'path', null);

export default selectGamePath;
